/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsPayrateGroup.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-payrate-group";

export class AutogenModelDrsPayrateGroup<RowType extends ModelRow> extends Endpoint<RowType, RowDrsPayrateGroupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsPayrateGroup extends ModelRow<RowDrsPayrateGroupFields> {
	constructor(values?: Partial<RowDrsPayrateGroupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsPayrateGroupFields {
	company_id: string;
	descr: string;
	id: string;
}

